import { mean, std } from 'mathjs';
import { CompSelectionProperty } from '../../types.ts';

const MAX_QUALITY_TIERS = 10;

export const calcQualityTier = (properties: CompSelectionProperty[]) : CompSelectionProperty[] => {
  const differences: number[] = [];
  const qualityTierProperties = properties.filter((p) => !!p.salePrice).sort((p1, p2) => p2.salePrice!.toDollarLike() - p1.salePrice!.toDollarLike());
  const soldPrices = qualityTierProperties.map((p) => p.salePrice!.toDollarLike());

  if (soldPrices.length < 2) {
    return qualityTierProperties;
  }

  qualityTierProperties.forEach((p, i) => {
    if (i === 0) return;
    differences.push(Math.abs(soldPrices[i]! - soldPrices[i - 1]!));
  });
  
  const standardDeviation = std(differences) as unknown as number;
  const meanDifference = mean(differences);
  const naturalBreak = meanDifference + 2 * standardDeviation;

  let currentTier = 1;

  qualityTierProperties.forEach((p, i) => {
    if (i === 0) {
      p.qualityTier = currentTier;
    } else {
      const diff = differences[i - 1];
      // We're limiting quality tiers to 10, so we don't want to go above that
      // Break into a new tier if the difference is greater than the natural break
      if (diff && diff > naturalBreak && currentTier < MAX_QUALITY_TIERS) {
        currentTier++;
      }
      p.qualityTier = currentTier;
    }
  });

  return qualityTierProperties;
}
